import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  Icon as SemanticIcon,
  Menu,
  Sidebar as SemanticSidebar
} from "semantic-ui-react";
import { persistor } from "../store";

import {
  hasCapability,
  VIEW_REIMBURSEMENTS,
  MODIFY_ORGANIZATION,
  VIEW_TRANSACTIONS
} from "../util/capability";

import Icon from "./Icon/index.js";

import RouteMenuItem from "./RouteMenuItem";

const logOut = () => {
  persistor.purge().then(function() {
    window.location = "/login";
  });
};

const MenuStyle = {
  width: "280px"
};

const _Sidebar = props => {
  return (
    <SemanticSidebar
      as={Menu}
      inverted
      vertical
      visible
      style={MenuStyle}
      size="massive"
      className="coloredSidebar"
    >
      <style>{`
      .coloredSidebar {
        background-color: #4267bb !important;
        background: #4267bb !important; /* Old browsers */
        background: -moz-linear-gradient(45deg, #4267bb 0%, #17357a 100%) !important; /* FF3.6-15 */
        background: -webkit-linear-gradient(45deg, #4267bb 0%,#17357a 100%) !important; /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(45deg, #4267bb 0%,#17357a 100%) !important; /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4267bb', endColorstr='#17357a',GradientType=1 ) !important; /* IE6-9 fallback on horizontal gradient */
      }
    `}</style>
      <Menu.Item>
        <div
          style={{
            textAlign: "center",
            fontSize: "2em",
            fontFamily: "Hammersmith One",
            marginTop: "0.2em"
          }}
        >
          <Icon icon="spout" /> Spout
        </div>
        <div style={{ textAlign: "center", marginTop: "1em" }}>
          {props.organizationName}
        </div>
      </Menu.Item>
      {hasCapability(VIEW_REIMBURSEMENTS) && (
        <RouteMenuItem url="/reimbursements">
          <SemanticIcon name="clipboard check" />Reimbursements
        </RouteMenuItem>
      )}
      {hasCapability(VIEW_TRANSACTIONS) && (
        <RouteMenuItem url="/transactions">
          <SemanticIcon name="university" />Bank Transactions
        </RouteMenuItem>
      )}
      {
        // <RouteMenuItem url="/budget">
        //   <SemanticIcon name="calculator" />Budget
        // </RouteMenuItem>
        // <RouteMenuItem url="/flow">
        //   <SemanticIcon name="dollar sign" />Money Flow
        // </RouteMenuItem>
        // <RouteMenuItem url="/analytics">
        //   <SemanticIcon name="chart pie" />Analytics
        // </RouteMenuItem>
      }
      {hasCapability(MODIFY_ORGANIZATION) && (
        <RouteMenuItem url="/settings">
          <SemanticIcon name="cogs" />Organization Settings
        </RouteMenuItem>
      )}
      <Menu.Item>
        <Menu.Header>{props.userName}</Menu.Header>
        <Menu.Menu>
          <RouteMenuItem url="/profile">Profile</RouteMenuItem>
          <Menu.Item onClick={logOut}>Log out</Menu.Item>
        </Menu.Menu>
      </Menu.Item>
    </SemanticSidebar>
  );
};

const mapStateToProps = state => ({
  organizationName: state.user.organization.name,
  userName: state.user.first_name + " " + state.user.last_name
});

const Sidebar = connect(mapStateToProps)(_Sidebar);

const SidebarWithRouter = withRouter(Sidebar);

export default SidebarWithRouter;



// WEBPACK FOOTER //
// ./frontend/src/components/Sidebar.js